class Modal {
  constructor() {
    $(".js-modal").magnificPopup({
      type: "inline",
      midClick: true,
      gallery: {
        enabled: true,
        arrowMarkup:
          '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%">%title%</button>',
        tPrev: "Back",
        tNext: "Next",
      },
      closeMarkup:
        '<button title="%title%" type="button" class="mfp-close"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 10.9053L1.11111 19.7942C0.973936 19.9314 0.823045 20 0.658436 20C0.493827 20 0.342936 19.9314 0.205761 19.7942C0.0685871 19.6571 0 19.5062 0 19.3416C0 19.177 0.0685871 19.0261 0.205761 18.8889L9.09465 10L0.205761 1.11111C0.0685871 0.973936 0 0.823045 0 0.658436C0 0.493827 0.0685871 0.342936 0.205761 0.205761C0.342936 0.0685871 0.493827 0 0.658436 0C0.823045 0 0.973936 0.0685871 1.11111 0.205761L10 9.09465L18.8889 0.205761C19.0261 0.0685871 19.177 0 19.3416 0C19.5062 0 19.6571 0.0685871 19.7942 0.205761C19.9314 0.342936 20 0.493827 20 0.658436C20 0.823045 19.9314 0.973936 19.7942 1.11111L10.9053 10L19.7942 18.8889C19.9314 19.0261 20 19.177 20 19.3416C20 19.5062 19.9314 19.6571 19.7942 19.7942C19.6571 19.9314 19.5062 20 19.3416 20C19.177 20 19.0261 19.9314 18.8889 19.7942L10 10.9053Z" fill="white"/></svg>閉じる</button>',
    });
  }
}

export { Modal };
